import * as React from 'react';
import { Container as LibGrid, ContainerProps as LibGridProps, useScreenClass } from 'react-grid-system';

export { useScreenClass } from 'react-grid-system';

interface GridProps {
    /**
     * Small, medium and large breakpoints are always fluid and the extra-large breakpoint defaults to fixed width.
     * If this is set to true, the extra-large breakpoint will also be fluid.
     */
    fluid?: LibGridProps['fluid'];

    /**
     * Specify component to use, defaults to 'div'.
     */
    component?: LibGridProps['component'];

    ref?: LibGridProps['ref'];
    style?: LibGridProps['style'];
}

export const Grid: React.FunctionComponent<React.PropsWithChildren<GridProps>> = (props) => {
    const { children, ref, fluid, style, ...rest } = props;
    const screenClass = useScreenClass();
    const padding = ['lg', 'xl'].includes(screenClass) ? 24 : 8;

    return (
        <LibGrid
            {...rest}
            style={{ paddingRight: padding, paddingLeft: padding, ...style }}
            fluid={fluid}
            ref={ref as React.LegacyRef<LibGrid> & React.LegacyRef<HTMLDivElement>}
        >
            {children}
        </LibGrid>
    );
};
